import Navbar from '../../components/feature/Navbar';
import SolutionsHero from './components/SolutionsHero';
import ServiceSection from './components/ServiceSection';
import SolutionsClosing from './components/SolutionsClosing';
import Footer from '../home/components/Footer';

const services = [
  {
    number: '01',
    title: 'AI Intake & Client Conversion Systems',
    description:
      'Automate client inquiries, consultations, and lead follow-ups using AI-driven workflows designed to increase conversion and reduce missed opportunities.',
    capabilities: [
      'Automated lead qualification',
      'Consultation booking automation',
      'AI conversation agents',
      'Pipeline automation',
    ],
    icon: 'ri-user-received-2-line',
    reversed: false,
    accentColor: '#28D7C6',
  },
  {
    number: '02',
    title: 'Client Communication Automation',
    description:
      'Structured messaging systems that keep clients informed, engaged, and progressing through your services — without manual effort.',
    capabilities: [
      'Appointment reminders',
      'Nurture sequences',
      'Service follow-ups',
      'Retention workflows',
    ],
    icon: 'ri-message-3-line',
    reversed: true,
    accentColor: '#2F6BFF',
  },
  {
    number: '03',
    title: 'Operational Workflow Automation',
    description:
      'Replace manual administrative processes with structured AI workflows designed for efficiency and consistency across your entire operation.',
    capabilities: [
      'Document workflows',
      'Intake processing',
      'Scheduling systems',
      'Task routing',
    ],
    icon: 'ri-flow-chart',
    reversed: false,
    accentColor: '#28D7C6',
  },
  {
    number: '04',
    title: 'Revenue Intelligence Dashboards',
    description:
      'Real-time insights into lead flow, conversion performance, and operational efficiency — giving you full visibility and control over business outcomes.',
    capabilities: [
      'Performance dashboards',
      'Revenue attribution',
      'Pipeline monitoring',
      'Operational reporting',
    ],
    icon: 'ri-bar-chart-2-line',
    reversed: true,
    accentColor: '#2F6BFF',
  },
];

export default function SolutionsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SolutionsHero />
      {services.map((service) => (
        <ServiceSection key={service.number} {...service} />
      ))}
      <div id="audit">
        <SolutionsClosing />
      </div>
      <Footer />
    </div>
  );
}
